import React from "react";
import { Zap, Facebook, Instagram, MessageCircle, Phone, Mail, MapPin } from "lucide-react";
import { companyInfo } from "../mock";

const Footer = () => {
  const links = ["Home", "About Us", "Services", "Projects", "Why Us", "Contact"];
  const serviceLinks = ["Electrical Contracting", "Solar Installation", "Maintenance", "Panel Installation"];

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="bg-[#0f2a5c] text-slate-200 pt-14 pb-6 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-full bg-[#F5B800] flex items-center justify-center">
              <Zap className="w-6 h-6 text-[#0f2a5c]" fill="#0f2a5c" />
            </div>
            <div className="leading-tight">
              <div className="text-white font-extrabold text-lg">BRAHMA</div>
              <div className="text-white font-extrabold text-lg -mt-1">ELECTRICAL</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-slate-300">Electrical Contractor & Solar Solutions</p>
          <div className="mt-5 flex items-center gap-3">
            <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full border border-slate-400/40 flex items-center justify-center hover:bg-[#F5B800] hover:border-[#F5B800] hover:text-[#0f2a5c] transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full border border-slate-400/40 flex items-center justify-center hover:bg-[#F5B800] hover:border-[#F5B800] hover:text-[#0f2a5c] transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href={`https://wa.me/${companyInfo.whatsapp}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="w-9 h-9 rounded-full border border-slate-400/40 flex items-center justify-center hover:bg-[#F5B800] hover:border-[#F5B800] hover:text-[#0f2a5c] transition-colors">
              <MessageCircle className="w-4 h-4" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-white font-bold text-lg">Quick Links</h4>
          <ul className="mt-5 space-y-3 text-sm">
            {links.map((l) => (
              <li key={l}>
                <a
                  href={`#${l.toLowerCase().replace(/\s/g, "")}`}
                  className="text-slate-300 hover:text-[#F5B800] transition-colors"
                >
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-white font-bold text-lg">Our Services</h4>
          <ul className="mt-5 space-y-3 text-sm">
            {serviceLinks.map((s) => (
              <li key={s}>
                <a href="#services" className="text-slate-300 hover:text-[#F5B800] transition-colors">{s}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-white font-bold text-lg">Contact Us</h4>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#F5B800] flex-shrink-0" />
              <a href={`tel:${companyInfo.phone.replace(/\s/g, "")}`} className="text-slate-300 hover:text-[#F5B800]">{companyInfo.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-[#F5B800] flex-shrink-0" />
              <a href={`mailto:${companyInfo.email}`} className="text-slate-300 hover:text-[#F5B800]">{companyInfo.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-[#F5B800] flex-shrink-0 mt-0.5" />
              <span className="text-slate-300">{companyInfo.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-12 border-t border-white/10 pt-5 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm text-slate-300">
          © 2024 Brahma Electrical. All Rights Reserved.
        </p>
      </div>

      <button
        onClick={scrollToTop}
        aria-label="Back to top"
        className="fixed bottom-6 right-6 w-11 h-11 rounded-md bg-[#F5B800] hover:bg-[#e0a800] text-[#0f2a5c] flex items-center justify-center shadow-xl transition-colors z-40"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
          <path d="M12 19V5" />
          <path d="m5 12 7-7 7 7" />
        </svg>
      </button>
    </footer>
  );
};

export default Footer;
